import React, { useState, useEffect } from 'react';
import { t } from '../utils/i18n';

const Login = ({ onLogin, api, onSwitchToRegister, onSwitchToForgotPassword }) => {
  const [formData, setFormData] = useState({
    armyId: '',
    armyType: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [armyTypes, setArmyTypes] = useState([]);
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchArmyTypes();
  }, []);

  const fetchArmyTypes = async () => {
    try {
      const data = await api.get('/army_types');
      setArmyTypes(data);
    } catch (error) {
      console.error('Failed to fetch army types:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/api/v1/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user: formData })
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('token', data.token);
        onLogin(data);
      } else {
        setError(data.error || 'Login failed');
      }
    } catch (err) {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    // Locate the element
    const mainSec = document.querySelector(".mainSec");
    if (mainSec) {
      mainSec.style.padding = "0";
    }
    return () => {
      if (mainSec) {
        mainSec.style.padding = "";
      }
    };
  }, []);

  return (
    <section className="posRel loginPg">
      <div className="loginBg">
        <img src="/images/Login-bg2.webp" alt="" />
      </div>
      <div className="loginBoxMain">

        <div className='box_card'>
          <div className='firstLogo_card'>
            <img src="/images/logo-head.png" alt="" />
          </div>

          <div className='box_card_inner'>
            <div className='box_blockCard'>
              <img src="/images/l1.png" alt="" />
            </div>
            <div className='box_blockCard box_blockCard_border'>
              <img src="/images/l2.png" alt="" />
            </div>

            <div className='box_blockCard'>
              <img src="/images/l3.png" alt="" />
            </div>
          </div>

          <div className='box_card_inner msg_card'>
            <div className='box_blockCard'>
              <div className='msg_innerCard'>
                <span>
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M28.0287 4.19875C27.9748 3.81195 27.6965 3.49378 27.3203 3.38921L15.2628 0.0360044C15.0909 -0.0118387 14.9093 -0.0118387 14.7373 0.0360044L2.67978 3.38921C2.30357 3.49378 2.02527 3.81182 1.97142 4.19875C1.90148 4.70162 0.306057 16.5835 4.39821 22.4943C8.48553 28.3981 14.5152 29.911 14.7698 29.9726C14.8455 29.9909 14.9227 29.9999 15 29.9999C15.0774 29.9999 15.1546 29.9908 15.2302 29.9726C15.485 29.911 21.5147 28.3981 25.6019 22.4943C29.694 16.5836 28.0986 4.70176 28.0287 4.19875ZM22.7756 11.1355L14.5512 19.3599C14.3598 19.5513 14.1088 19.6471 13.858 19.6471C13.6071 19.6471 13.3561 19.5514 13.1647 19.3599L8.07965 14.2748C7.89573 14.091 7.79246 13.8416 7.79246 13.5816C7.79246 13.3216 7.89586 13.0722 8.07965 12.8884L9.08932 11.8787C9.4722 11.496 10.093 11.4959 10.4757 11.8787L13.858 15.261L20.3795 8.73927C20.5633 8.55535 20.8127 8.45208 21.0727 8.45208C21.3327 8.45208 21.5821 8.55535 21.7659 8.73927L22.7756 9.74895C23.1585 10.1318 23.1585 10.7526 22.7756 11.1355Z" fill="#11BCB0" />
                  </svg>
                </span>
                <div className='title_msgCard'>
                  <h4>Secure Access</h4>
                  <p>This system is for authorize users only.</p>
                </div>
              </div>
            </div>

            <div className='box_blockCard box_blockCard_border'>
              <div className='msg_innerCard'>
                <span>
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1096_715)">
                      <path d="M25.6694 16.0149H23.3494C23.5859 16.6624 23.715 17.3611 23.715 18.0893V26.8579C23.715 27.1616 23.6622 27.453 23.566 27.7241H27.4017C28.8345 27.7241 30.0001 26.5584 30.0001 25.1257V20.3455C30.0001 17.9576 28.0574 16.0149 25.6694 16.0149Z" fill="#11BCB0" />
                      <path d="M6.28507 18.0893C6.28507 17.361 6.41427 16.6624 6.65075 16.0149H4.33067C1.94274 16.0149 0 17.9576 0 20.3456V25.1257C0 26.5584 1.16561 27.7241 2.5984 27.7241H6.43407C6.33792 27.4529 6.28507 27.1616 6.28507 26.8579V18.0893Z" fill="#11BCB0" />
                      <path d="M17.652 13.7587H12.348C9.96007 13.7587 8.01733 15.7014 8.01733 18.0893V26.8579C8.01733 27.3362 8.40511 27.724 8.88347 27.724H21.1166C21.5949 27.724 21.9827 27.3363 21.9827 26.8579V18.0893C21.9827 15.7014 20.04 13.7587 17.652 13.7587Z" fill="#11BCB0" />
                      <path d="M14.9999 2.27576C12.1281 2.27576 9.79175 4.61213 9.79175 7.48399C9.79175 9.43194 10.8669 11.1332 12.4547 12.0264C13.2078 12.4501 14.076 12.6922 14.9999 12.6922C15.9238 12.6922 16.7921 12.4501 17.5452 12.0264C19.133 11.1332 20.2081 9.43188 20.2081 7.48399C20.2081 4.61219 17.8717 2.27576 14.9999 2.27576Z" fill="#11BCB0" />
                      <path d="M5.8545 7.13025C3.70674 7.13025 1.95947 8.87752 1.95947 11.0253C1.95947 13.173 3.70674 14.9203 5.8545 14.9203C6.39931 14.9203 6.9181 14.8075 7.38937 14.6046C8.20417 14.2538 8.87601 13.6328 9.29173 12.855C9.58353 12.3091 9.74953 11.6863 9.74953 11.0253C9.74953 8.87758 8.00226 7.13025 5.8545 7.13025Z" fill="#11BCB0" />
                      <path d="M24.1455 7.13025C21.9978 7.13025 20.2505 8.87752 20.2505 11.0253C20.2505 11.6863 20.4165 12.3091 20.7083 12.855C21.124 13.6329 21.7958 14.2539 22.6106 14.6046C23.0819 14.8075 23.6007 14.9203 24.1455 14.9203C26.2933 14.9203 28.0405 13.173 28.0405 11.0253C28.0405 8.87752 26.2933 7.13025 24.1455 7.13025Z" fill="#11BCB0" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1096_715">
                        <rect width="30" height="30" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>

                </span>
                <div className='title_msgCard'>
                  <h4>Confidental</h4>
                  <p>All activities are monitored and recorded.</p>
                </div>
              </div>
            </div>


            <div className='box_blockCard'>
              <div className='msg_innerCard'>
                <span>
                  <svg width="23" height="30" viewBox="0 0 23 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.6875 11.25H18.75V7.5C18.75 3.36375 15.3862 0 11.25 0C7.11375 0 3.75 3.36375 3.75 7.5V11.25H2.8125C1.2625 11.25 0 12.5112 0 14.0625V27.1875C0 28.7388 1.2625 30 2.8125 30H19.6875C21.2375 30 22.5 28.7388 22.5 27.1875V14.0625C22.5 12.5112 21.2375 11.25 19.6875 11.25ZM6.25 7.5C6.25 4.7425 8.4925 2.5 11.25 2.5C14.0075 2.5 16.25 4.7425 16.25 7.5V11.25H6.25V7.5ZM12.5 20.9025V23.75C12.5 24.44 11.9412 25 11.25 25C10.5588 25 10 24.44 10 23.75V20.9025C9.25625 20.4688 8.75 19.6712 8.75 18.75C8.75 17.3713 9.87125 16.25 11.25 16.25C12.6287 16.25 13.75 17.3713 13.75 18.75C13.75 19.6712 13.2437 20.4688 12.5 20.9025Z" fill="#11BCB0" />
                  </svg>

                </span>
                <div className='title_msgCard'>
                  <h4>Protect & serve</h4>
                  <p>Committed to security, integrity and excellence.</p>
                </div>
              </div>
            </div>
          </div>


        </div>

        <div className="loginBox">
          {/* <a href="#" className="mAuto mb_24 loginLogo">
            <img src="/images/logo.png" alt="" />
          </a> */}
          <div className='mAuto mb_24 loginLogoBox'>
            <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M50.8369 8.22441C42.8335 8.22441 32.3033 5.52376 28.5498 0.520267C28.0505 -0.0877562 27.1529 -0.175456 26.5449 0.323887C26.4731 0.382633 26.4073 0.448512 26.3485 0.520267C22.5946 5.52334 12.0644 8.22441 4.06147 8.22441C3.30154 8.22441 2.68555 8.8404 2.68555 9.60033V27.4848C2.68555 42.6127 15.8225 51.7327 27.0715 54.9461C27.3182 55.0178 27.5801 55.0178 27.8268 54.9461C39.0759 51.7327 52.2128 42.6127 52.2128 27.4848V9.60033C52.2128 8.8404 51.5968 8.22441 50.8369 8.22441ZM49.4609 27.4848C49.4609 40.9146 37.692 49.1474 27.4492 52.1922C17.2063 49.1474 5.43697 40.9146 5.43697 27.4848V10.9519C13.3891 10.6829 22.7927 8.1195 27.4492 3.43618C32.1061 8.1195 41.5092 10.6829 49.4614 10.9515V27.4848H49.4609Z" fill="white" />
              <path d="M21.9464 21.982V24.7334H20.5705C19.8106 24.7334 19.1946 25.3494 19.1946 26.1093V37.115C19.1946 37.8749 19.8106 38.4909 20.5705 38.4909H34.328C35.0879 38.4909 35.7039 37.8749 35.7039 37.115V26.1093C35.7039 25.3494 35.0879 24.7334 34.328 24.7334H32.9521V21.982C32.9521 18.9427 30.4885 16.4791 27.4493 16.4791C24.41 16.4791 21.9464 18.9427 21.9464 21.982ZM32.9521 35.7395H21.9464V27.4848H32.9521V35.7395ZM30.2007 21.982V24.7334H24.6978V21.982C24.6978 20.4625 25.9294 19.2305 27.4493 19.2305C28.9687 19.2305 30.2007 20.4625 30.2007 21.982Z" fill="white" />
            </svg>


          </div>
          <div className="textCenter maxW_300 mAuto mb_24 loginHD">
            <h1 className="colorTextDark mb_16">Login</h1>
            <p>Sign in to access your account</p>
          </div>
          <div className="lsForm">
            {error && <div style={{ color: 'red', marginBottom: '16px' }}>{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="formInpt mb_20">
                <label className="mb_8" htmlFor="armyId">Army ID</label>
                <input
                  id="armyId"
                  name="armyId"
                  type="text"
                  placeholder="Enter Army ID"
                  value={formData.armyId}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="formInpt mb_20">
                <label className="mb_8">{t('army_type')}</label>
                <select
                  name="armyType"
                  className="customSelect"
                  value={formData.armyType}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Army Type...</option>
                  {armyTypes.map(type => (
                    <option key={type.id} value={type.id}>{type.name}</option>
                  ))}
                </select>
              </div>

              <div className="formInpt shPW mb_20">
                <label className="mb_8" htmlFor="password">Password</label>
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className={showPassword ? "show" : "hide"}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <img className="showPW" src="/images/pshImgShow.png" alt="" />
                  <img className="hidePW" src="/images/pshImgHide.png" alt="" />
                </button>
              </div>

              <div className="dFlex rmWrap mb_20">
                <label className="tccL fwMedium">
                  <input
                    type="checkbox"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  Remember Me
                </label>
                <button type="button" className="dBlock fwBold forgotPass"
                  onClick={(e) => {
                    e.preventDefault();
                    onSwitchToForgotPassword();
                  }}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  Forgot Password?
                </button>
              </div>

              <input
                type="submit"
                value={loading ? "Logging in..." : "Login"}
                className="btnBig fullWidth login_btn"
                disabled={loading}
              />
            </form>
          </div>
        </div>
      </div>

      <div className='footer_loginBoard'>
        <div className='footer_loginInner'>
          <span className='line_logo'>
            <svg width="78" height="7" viewBox="0 0 78 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="3.77417" y1="3.14526" x2="75.4838" y2="3.14526" stroke="#10CECC" stroke-width="1.25806" />
              <circle cx="3.14516" cy="3.14516" r="3.14516" fill="#10CECC" />
              <circle cx="74.8549" cy="3.14516" r="3.14516" fill="#10CECC" />
            </svg>
          </span>

          <span>
            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.8125 6.75H11.25V4.5C11.25 2.01825 9.23175 0 6.75 0C4.26825 0 2.25 2.01825 2.25 4.5V6.75H1.6875C0.7575 6.75 0 7.50675 0 8.4375V16.3125C0 17.2432 0.7575 18 1.6875 18H11.8125C12.7425 18 13.5 17.2432 13.5 16.3125V8.4375C13.5 7.50675 12.7425 6.75 11.8125 6.75ZM3.75 4.5C3.75 2.8455 5.0955 1.5 6.75 1.5C8.4045 1.5 9.75 2.8455 9.75 4.5V6.75H3.75V4.5ZM7.5 12.5415V14.25C7.5 14.664 7.16475 15 6.75 15C6.33525 15 6 14.664 6 14.25V12.5415C5.55375 12.2812 5.25 11.8027 5.25 11.25C5.25 10.4227 5.92275 9.75 6.75 9.75C7.57725 9.75 8.25 10.4227 8.25 11.25C8.25 11.8027 7.94625 12.2812 7.5 12.5415Z" fill="#10CECC" />
            </svg>
          </span>

          <p>2026 Puntland State of Somalia. All Rights Reserved.</p>

          <span>
            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.8125 6.75H11.25V4.5C11.25 2.01825 9.23175 0 6.75 0C4.26825 0 2.25 2.01825 2.25 4.5V6.75H1.6875C0.7575 6.75 0 7.50675 0 8.4375V16.3125C0 17.2432 0.7575 18 1.6875 18H11.8125C12.7425 18 13.5 17.2432 13.5 16.3125V8.4375C13.5 7.50675 12.7425 6.75 11.8125 6.75ZM3.75 4.5C3.75 2.8455 5.0955 1.5 6.75 1.5C8.4045 1.5 9.75 2.8455 9.75 4.5V6.75H3.75V4.5ZM7.5 12.5415V14.25C7.5 14.664 7.16475 15 6.75 15C6.33525 15 6 14.664 6 14.25V12.5415C5.55375 12.2812 5.25 11.8027 5.25 11.25C5.25 10.4227 5.92275 9.75 6.75 9.75C7.57725 9.75 8.25 10.4227 8.25 11.25C8.25 11.8027 7.94625 12.2812 7.5 12.5415Z" fill="#10CECC" />
            </svg>
          </span>
          <span className='line_logo'>
            <svg width="78" height="7" viewBox="0 0 78 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="3.77417" y1="3.14526" x2="75.4838" y2="3.14526" stroke="#10CECC" stroke-width="1.25806" />
              <circle cx="3.14516" cy="3.14516" r="3.14516" fill="#10CECC" />
              <circle cx="74.8549" cy="3.14516" r="3.14516" fill="#10CECC" />
            </svg>

          </span>


        </div>
      </div>
    </section>
  );
};

export default Login;
